import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenicationService } from '../../_services/authenication.service';
import {ActivatedRoute, Router} from '@angular/router';
import jwt_decode from 'jwt-decode';


import { ToasterService } from '../../_services/toaster.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  submitted = false;
  returnUrl: string;
  alert: string;
  userAgent: string;
  usersTypeList: any[] = ['admin','subadmin','supersubadmin','employee','employee1','employee2','employee3'];

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private authenicationService: AuthenicationService, private toaster: ToasterService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userAgent = window.navigator.userAgent;
    // DynamicScriptLoaderServiceService.adminScripts();
    if (this.authenicationService.currentUserValue) {
      this.router.navigate(['/']);
    }

    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
    if (this.returnUrl == '/'){
      this.returnUrl = '/';
    }


  }


  get f() { return this.loginForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.spinnerService.hide();
      return;
    }
    // const encrypted = this.EncrDecr.setEncry('123456$#@$^@1ERF', this.loginForm.controls.password.value);
    const loginPayload = {
      users_email: this.loginForm.controls.email.value,
      users_password: btoa(btoa(this.loginForm.controls.password.value)),
      user_type:'internal',
      userAgent: this.userAgent,
      // enc_data: encrypted
    };

    this.authenicationService.login(loginPayload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {

            if(this.usersTypeList.includes(data.userType) == true) {
              const decoded = jwt_decode(data.jwt);
              localStorage.setItem('userDetails', btoa(JSON.stringify(decoded)));
              this.authenicationService.userDetails();

              //this.toaster.showSuccess('Login', data.ResponseMessage);
              location.href = this.returnUrl;
            }
            else{
              this.toaster.showError('Login', 'Wrong Admin Crediantials');
            }
            // setTimeout(() => {
            //  this.router.navigate([this.returnUrl]);
            // }, 1000);  // 5s
            // location.reload();
          } else {
            this.toaster.showError('Login', data.ResponseMessage);
          }
        },
        error => {
          this.submitted = false;
          this.toaster.showError('Login', error.error.ResponseMessage);
        });
  }

}
